// removed by extract-text-webpack-plugin
module.exports = {"headerBar":"headerBar___7E66E"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/HeaderBar.module.less
// module id = 746
// module chunks = 0